// extracted by mini-css-extract-plugin
export var centered = "_b-6";
export var flexible = "_b-5";
export var footer = "_b-k";
export var footerBorder = "_b-l";
export var header = "_b-c";
export var headerBorder = "_b-d";
export var headerDefault = "_b-g";
export var headerMedium = "_b-h";
export var headerPadding = "_b-e";
export var iconAndTitle = "_b-f";
export var large = "_b-4";
export var largePadding = "_b-a";
export var medium = "_b-3";
export var mediumPadding = "_b-9";
export var modal = "_b-0";
export var modalContainer = "_b-b";
export var noPadding = "_b-7";
export var skinny = "_b-1";
export var small = "_b-2";
export var smallPadding = "_b-8";
export var subtitle = "_b-j";
export var title = "_b-i";